export class TeamsRow {
  constructor({
    id = 1,
    quantity = 0,
    extension = 500,
    extensionName = null,
    contractLength = 0,
    handsetID = 0,
    ratePlanID = 0,
    ani = null,
    saved = false,
  } = {}) {
    this.id = id;
    this.extension = extension;
    this.extensionName = extensionName;
    this.contractLength = contractLength;
    this.ratePlanID = ratePlanID;
    this.ani = ani;
    this.saved = saved;
    this.quantity = quantity;
    this.handsetID = handsetID
  }
}
export function createNewTeamsRow(data) {
  return Object.freeze(new TeamsRow(data));
}
